import React from "react";
import Header from"../components/header/header";
import Footer from "../components/footer/footer";
import APropos from "../components/apropos";

const Home = () => {
  return (
    <header id="header">
            <Header />

      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  Hello ! Moi c'est Swaly !
                  <span></span>
                </h1>
                <br></br>
                <br></br>
                <p>Seul ou à plusieurs,
                  <br></br>
                 Ensemble nous atteindrons vos objectifs !</p>
                <a
                  href="#apropos"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  A propos
                </a>{" "}
                </div>
            </div>                
          </div>                
        </div>
 

      </div>   
      <APropos />
        
      <Footer />


    </header>             

  );
};
export default Home;